export enum FlagEnumeration {
	yes = 'yes',
	no = 'no',
}
